import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5 0.5C15.6562 0.635417 15.7448 0.807292 15.7656 1.01562C15.7865 1.21354 15.7292 1.39583 15.5938 1.5625L7.10938 11.7188C7.04688 11.8021 6.96875 11.8698 6.875 11.9219C6.78125 11.9635 6.68229 11.9844 6.57812 11.9844C6.47396 11.9948 6.36979 11.9844 6.26562 11.9531C6.17188 11.9115 6.08854 11.8542 6.01562 11.7812L0.53125 7.0625C0.375 6.91667 0.291667 6.73958 0.28125 6.53125C0.28125 6.32292 0.354167 6.14583 0.5 6C0.645833 5.85417 0.817708 5.77604 1.01562 5.76562C1.22396 5.75521 1.40625 5.82292 1.5625 5.96875L6.46875 10.1406L14.4375 0.59375C14.5729 0.4375 14.7448 0.348958 14.9531 0.328125C15.1615 0.307292 15.3438 0.364583 15.5 0.5Z",
		fill: "#002E5F"
	})
});
const ForwardRef = forwardRef(SvgCheckmark);
export default ForwardRef;
